<template>
  <div class="mega-form">
    <div class="header">
      {{ header }}
    </div>
    <div class="field">
      <slot />
    </div>
    <div
      v-if="item"
    >
      <div
        v-for="(key, i) in Object.keys(item)"
        :key="i"
        class="field"
      >
        <div class="label">
          {{ item[key].label || key }}
        </div>
        <textarea
          v-if="item[key].type === 'textarea'"
          v-model="item[key].value"
        />
        <input
          v-else
          v-model="item[key].value"
          :type="item[key].type || 'text'"
          :disabled="key === 'id' || key === '__typename'
            || key === 'grants' || key === 'apps' || item[key].disabled"
        >
      </div>
    </div>
    <div class="buttons">
      <div
        v-for="(button, i) in buttons"
        :key="i"
        class="button"
      >
        <btn
          :name="button.name"
          :class="{'disabled': disabled}"
          @click="emit(button, item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MegaForm',
    components: {
      btn: () => import('@/views/admin/components/btn.vue'),
    },
    props: {
      item: {
        type: Object,
        default: null,
      },
      header: {
        type: String,
        default: 'Mega form header',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      buttons: {
        type: Array,
        default: () => [{ name: 'Save', callback: 'save' }],
      },
    },
    data() {
      return {
      };
    },
    apollo: {},
    computed: {},
    watch: {},
    mounted() {
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
          if (e.target.tagName === 'TEXTAREA') {
            return;
          }
          this.$emit('save', this.item);
        }
      });
    },
    methods: {
      emit(i, item) {
        this.$eventBus.$emit(i.callback, item);
      },
    },
  };
</script>

<style lang="stylus" scoped>
  @require '~@/style/type'

  $input
    @extend $type-normal
    border: 1px solid #e8e8e8
    border-radius: 5px
    box-sizing: border-box
    color: #35495e
    display: block
    height 40px
    padding: 0 13px
    width: 100%

  $textarea
    @extend $input
    height: 100px
    padding-bottom: 10px
    padding-top: 10px
    resize: none

  $label
    display: block
    margin-bottom: 5px
    text-transform: capitalize

  .mega-form
    background-color: white
    padding: 30px
    min-width: 500px
    min-height: 200px

  .header
    font-weight: bold
    margin-bottom: 15px

  .buttons
    display: flex
    justify-content: flex-end

  .label
    @extend $label

  .field
    margin-bottom: 10px

  .btn.disabled
    opacity: 0.5
    pointer-events: none

  .btn
    cursor: pointer

  .button:not(:last-child)
    margin-right: 10px

  input[type=email],
  input[type=password],
  input[type=text],
  input[type=url]
    @extend $input

  textarea
    @extend $textarea
</style>
